export default {
  name: 'TargetIconV2',
  props: {
    width: {
      type: Number,
      default: 12
    },
    height: {
      type: Number,
      default: 12
    },
    color: {
      type: String,
      default: '#757575'
    }
  }
};